import React, { Component } from 'react';
import moment from 'moment';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import withPreferenceOptions from '../../common/withPreferenceOptions';
import withGoBack from '../../common/withGoBack';
import Bugsnag from '../../helpers/bugsnag';
import { onGoBack } from '../../common/globals';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';

class PreferenceOptions extends Component {
  constructor(props) {
    super(props);
    this.preferenceOptionsModal = null;
  }

  componentDidMount() {
    this.preferenceOptionsModal = new window.bootstrap.Modal(window.$('#preferenceOptionsModal'));
  }

  _updateSelectedSetsPayload = (set) => {
    const { selectedSetsPayload, setSelectedSetsPayload } = this.props;
    const findIndex = _.findIndex(selectedSetsPayload,
      { SetName: set.SetName, PreferenceName: set.PreferenceName });
    if (findIndex > -1) {
      // TODO: check if delete mode then set priority to remove
      selectedSetsPayload[findIndex].Quantity = set.Quantity;
    } else {
      selectedSetsPayload.push({ ...set });
    }
    setSelectedSetsPayload([...selectedSetsPayload]);
  }

  _onReplace = () => {
    try {
      const {
        selectedPreference, setPreferenceOptions, caseRes, goBack, onHide,
        selectedSetsPayload, setSelectedSetsPayload
      } = this.props;
      const preferenceOptions = {};
      let preferenceComments = {};
      let preferenceRepNotes = {};

      selectedSetsPayload.map((set, index) => {
        selectedSetsPayload[index].Quantity = 0;
      });

      const filteredSetsPayload = selectedSetsPayload.filter(({ CasePlanId }) => CasePlanId);

      setSelectedSetsPayload([...filteredSetsPayload]);

      selectedPreference.map((set) => {
        set.CasePlanID = '';
        const {
          SetName, Quantity, Comments, RepNotes
        } = set;
        this._updateSelectedSetsPayload(set);
        preferenceOptions[SetName] = Number(Quantity);
        preferenceComments = Comments;
        preferenceRepNotes = RepNotes;
      });
      setPreferenceOptions({
        data: preferenceOptions, type: 'replace', preferenceComments, preferenceRepNotes
      });

      onHide();
      browserHistory.push(`/manage-case/${caseRes.id}/sets`);
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAppend = async () => {
    try {
      const {
        setPreferenceOptions, caseRes, goBack, onHide, selectedPreference, selectedSetsPayload
      } = this.props;
      const preferenceOptions = {};
      let preferenceComments = {};
      let preferenceRepNotes = {};
      selectedPreference.map((set) => {
        set.CasePlanID = '';
        const {
          SetName, Quantity, Comments, RepNotes
        } = set;

        const setPayload = { ...set };
        const findIndex = _.findIndex(selectedSetsPayload,
          { SetName: setPayload.SetName, PreferenceName: setPayload.PreferenceName });
        if (findIndex >= 0) {
          setPayload.Quantity = Number(setPayload.Quantity)
              + Number(selectedSetsPayload[findIndex].Quantity);
        }
        this._updateSelectedSetsPayload(setPayload);
        preferenceOptions[SetName] = Number(Quantity);
        preferenceComments = Comments;
        preferenceRepNotes = RepNotes;
      });
      setPreferenceOptions({
        data: preferenceOptions,
        type: 'append',
        preferenceComments,
        preferenceRepNotes
      });

      onHide();
      browserHistory.push(`/manage-case/${caseRes.id}/sets`);
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { caseDate, selectedSetsCount } = this.props;
    const dateRes = moment().format('YYYY-MM-DD') >= caseDate;
    // case date is grater then current date open replace pop up
    // case date is less then current date open append pop up
    return (
      <div
        className="modal fade theme-modal qty-modal" id="preferenceOptionsModal"
        tabIndex="-1" aria-labelledby="preferenceOptionsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="preferenceOptionsModalLabel">Preference Options</h5>
              {
                (!dateRes)
                  ? (
                    <p>{`You have ${selectedSetsCount} ${selectedSetsCount > 1 ? 'sets' : 'set'} selected for this case. You can either replace or append to these sets/notes`}
                    </p>
                  )
                  : (
                    <p>{`You have ${selectedSetsCount} ${selectedSetsCount > 1 ? 'sets' : 'set'} selected for this case.It will append to these sets/notes.`}
                    </p>
                  )
              }

            </div>
            <div className="modal-footer">
              {
                (!dateRes)
                  ? (
                    <div className="row gx-2 button-wrap">
                      <div className="col-4">
                        <button type="button" className="btn btn-link btn-left w-100" onClick={this._onReplace}>Replace</button>
                      </div>
                      <div className="col-4">
                        <button type="button" className="btn btn-link btn-left w-100" onClick={this._onAppend}>Append</button>
                      </div>
                      <div className="col-4">
                        <button type="button" className="btn btn-link w-100" data-bs-dismiss="modal">Cancel</button>
                      </div>
                    </div>
                  )
                  : (
                    <div className="row gx-2 button-wrap">
                      <div className="col-6">
                        <button type="button" className="btn btn-link btn-left w-100" onClick={this._onAppend}>APPEND</button>
                      </div>
                      <div className="col-6">
                        <button type="button" className="btn btn-link w-100" data-bs-dismiss="modal">Cancel</button>
                      </div>
                    </div>
                  )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withGoBack(withPreferenceOptions(
  withSelectedSetsPayload(PreferenceOptions)
));
